import { ISofaTaskPaneStrings } from "./myStrings.model";

export const CZ = (): ISofaTaskPaneStrings => {
  return {
    // Add to sofa strings
    documentTypesLabel: "Typ souboru",
    documentTypesPlaceholder: "Vyberte typ dokumentu",
    isDocumentClosed: "Archivovat dokument",
    back: "Zpět",
    buttonSubmit: "Odeslat do Sofa",
    // Common strings
    buttonCancel: "Zrušit",
    initializedErrorMessage: "Nepovedlo se spustit aplikaci, nebo nemáte přístup do Sofa. Zkuste to, prosím, znovu.",
    noAccessToSofa: "Nepovedlo se získat data, zkontrolujte, zda máte přístup do Sofa.",
    noLogin: "Nastal problém při získání jména dokumentu, pro správné fungování doplňku je nutné být přihlášen.",
    open: "Otevřít",
    save: "Uložit",
    // Dialog strings
    dialogValidationTitle: "Kontrola formuláře",
    dialogValidationSubtitle: "Prosím vyplňte všechna povinná pole.",
    dialogSuccessTitle: "Úspěch",
    dialogSuccessSubtitle: "Váš dokument byl úspěšně odeslán do Sofa.",
    dialogErrorTitle: "Chyba",
    dialogErrorSubtitle: "Chyba při ukládání dokumentu. Zkuste to, prosím, znovu.",
    errorMessageFieldName: "Maximální délka názvu je 255 znaků",
    dialogPopUpWarning: "Pro zobrazení agendy je potřeba povolit vyskakovací okna pro tento web.",
    // Agenda strings
    agendaTitle: "Spustit agendu",
    agendaSuccessfullyStarted: "Agenda byla zahájena, pokračujte na záložce vašeho výchozího internetového prohlížeče.",
    archiveTitle: "Odeslat do archivu",
    errorTitle: "Chyba",
    // Sign Point strings
    signPointTitle: "Podepisování souboru",
    // ISDS strings
    sendToISDSTitle: "Odesílání do datové schránky",
    isdsIsNotAvailable: "Agenda pro odeslání zprávy datovou schránkou není dostupná.",
    // Send to agenda strings
    classifyFile: "Provádím klasifikaci souboru",
    getFileId: "Získávám ID souboru",
    orderAgenda: "Objednat agendu",
    orderAgendaText: "Nemáte aktivní Sofa SignPoint agendu.",
    savingFile: "Ukládám soubor",
    startSignPoint: "Startuji agendu",
    // Signed agenda states
    error: "Během podepisování došlo k chybě, zkuste to znovu.",
    info: "Probíhá podepisování.",
    severeWarning: "Vypršela platnost operace, dokument nebyl podepsán.",
    success: "Podepisování bylo úspěsně dokončeno.",
    warning: "Akce byla zrušena, formulář pro podepisování byl zavřen.",
  };
};
